import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { FormStepId } from 'shared/config/formStepId';

import type { StateUser } from '../types';

import { queries } from './user.query';

const initialState: StateUser = {
  account: undefined,
  isLoggedIn: false,
  restoredAccount: null,
  esiaErrorCount: 0,
  deviceId: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<StateUser['account']>) => {
      state.isLoggedIn = true;
      state.account = payload;
    },
    addEsiaErrorAttempt: (state) => {
      state.esiaErrorCount += 1;
    },
    setEsiaStep: (state, { payload }: PayloadAction<FormStepId>) => {
      state.esiaStep = payload;
    },
    saveRestoredUserId: (state, { payload }: PayloadAction<StateUser['restoredAccount']>) => {
      state.restoredAccount = payload;
    },
    destroyUser: () => initialState,
    setDeviceId: (state, { payload }: PayloadAction<StateUser['deviceId']>) => {
      state.deviceId = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      queries.endpoints.getUserInfo.matchFulfilled,
      (state, { payload }: PayloadAction<StateUser['account']>) => ({
        ...state,
        account: payload,
        isLoggedIn: true,
      }),
    );
    builder.addMatcher(queries.endpoints.getUserInfo.matchRejected, (state) => ({
      ...state,
      isLoggedIn: false,
    }));
  },
});

export const { addEsiaErrorAttempt, setEsiaStep, saveRestoredUserId, setUser, destroyUser, setDeviceId } =
  userSlice.actions;
